import React from 'react';
import { useI18n } from '../i18n/LanguageContext';
import siteImageManifest from '../data/siteImageManifest.generated.json';

export default function Mission() {
  const { t } = useI18n();
  const roadmapItems = t('mission.roadmap');
  const items = Array.isArray(roadmapItems) ? roadmapItems : [];
  const v = typeof siteImageManifest?.generatedAt === 'string' ? siteImageManifest.generatedAt : '';
  const suffix = v ? `?v=${encodeURIComponent(v)}` : '';

  return (
    <section className="yk-page yk-missionPage">
      <div className="yk-productHero is-centered">
        <h1 className="yk-h1">{t('mission.title')}</h1>
        <p className="yk-lead">{t('mission.subtitle')}</p>
      </div>

      <div className="yk-card yk-missionCard">
        <div className="yk-missionTimeline" role="list" aria-label={t('mission.ariaRoadmap')}>
          <div className="yk-missionLine" aria-hidden="true" />

          {items.map((item, index) => {
            const isLeft = index % 2 === 0;
            const cardClass = isLeft ? 'yk-missionItemCard is-left' : 'yk-missionItemCard is-right';
            const mediaClass = isLeft ? 'yk-missionMediaCard is-right' : 'yk-missionMediaCard is-left';
            const mediaCardClass = item.year === '2026' ? `${mediaClass} is-contain` : mediaClass;
            const mediaImgClass = item.year === '2026' ? 'yk-missionMediaImg is-contain' : 'yk-missionMediaImg';
            const rowClass = item.year === '2026' ? 'yk-missionRow is-current' : 'yk-missionRow';
            const imageSrc = `${process.env.PUBLIC_URL}/images/istorie/${item.image}${suffix}`;
            const firstColClass = isLeft ? 'yk-missionCol is-textContent' : 'yk-missionCol is-imageContent';
            const secondColClass = isLeft ? 'yk-missionCol is-imageContent' : 'yk-missionCol is-textContent';

            return (
              <div key={item.year} className={rowClass} role="listitem">
                <div className={firstColClass}>
                  {isLeft ? (
                    <article className={cardClass}>
                      <div className="yk-missionYearBadge">{item.year}</div>
                      <h3 className="yk-missionItemTitle">{item.title}</h3>
                      <p className="yk-missionItemText">{item.text}</p>
                    </article>
                  ) : (
                    <figure className={mediaCardClass}>
                      <img
                        src={imageSrc}
                        alt={`${item.year} - ${item.title}`}
                        className={mediaImgClass}
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                  )}
                </div>

                <div className="yk-missionCenter" aria-hidden="true">
                  <span className="yk-missionDot" />
                </div>

                <div className={secondColClass}>
                  {!isLeft ? (
                    <article className={cardClass}>
                      <div className="yk-missionYearBadge">{item.year}</div>
                      <h3 className="yk-missionItemTitle">{item.title}</h3>
                      <p className="yk-missionItemText">{item.text}</p>
                    </article>
                  ) : (
                    <figure className={mediaCardClass}>
                      <img
                        src={imageSrc}
                        alt={`${item.year} - ${item.title}`}
                        className={mediaImgClass}
                        loading="lazy"
                        decoding="async"
                      />
                    </figure>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
